module.exports = __webpack_public_path__ + "static/media/undraw_Load_more_2yd7.0738102c.svg";